import { createTypedNanoEvents } from '@pkg/server/events/adapters/createTypedNanoEvents'
import { createAppEvents } from '@pkg/sync/client/createAppEvents'
import { createCrossTabEvents } from '@pkg/sync/client/createCrossTabEvents'
import type { SyncRuntimeEvent } from '@pkg/sync/client/syncRuntime'

// Auth-related events
export type AuthSessionUpdatedEvent = { type: 'auth.session.updated' }
export type AuthActivityEvent = { type: 'auth.activity'; timestamp: Date }
export type AuthLogoutEvent = { type: 'auth.logout' }

// Session expiry events
export type SessionExpiredEvent = { type: 'session.expired' }

// App event union (includes both app-specific and sync events)
export type AppClientEvent =
  | AuthSessionUpdatedEvent
  | AuthActivityEvent
  | AuthLogoutEvent
  | SessionExpiredEvent
  // Sync events
  | SyncRuntimeEvent

// Create typed nanoevents
const { events: localEvents } = createTypedNanoEvents<AppClientEvent>()

// Wrap with cross-tab sync
const crossTab = createCrossTabEvents<AppClientEvent>('icare:app-events', localEvents)

// Create type-safe app events wrapper
export const appEvents = createAppEvents<AppClientEvent>(crossTab as never)

export const appEventsRuntime = crossTab
